import type { Ref } from 'vue';
import type { DateTime, Interval } from 'luxon';

export type Override<Type, NewType> = Omit<Type, keyof NewType> & NewType;

export type ZvdZID = number | string;

export type ZvdZGuid = string;

export type WithRefs<M> = {
  [P in keyof M]: M[P] | Ref<M[P]>;
};

// This enum must be the same as on the backend.
// Because we only use the keys, the keys should be in alphabetical order.
export enum KnownExceptionKey {
  ApplicatieFout,
  GeenZiekteherstelmeldingGevonden,
  GeneralServerError,
  NietGeautoriseerd,
  NullReference,
  PaginaNietGevonden,
  SsoGebruikersnaamOnbekend,
  ToegangsverzoekUitgelogd,
  OnjuisteActivatieCode,
  OnjuistWachtwoord,
  EmailBestaat,
  OnjuisteVerificatieCode,
}

export type KnownError = {
  key: keyof KnownExceptionKey;
  description: string;
  metaData?: Record<string, unknown>;
};

export type ZvdZStandardModel = {
  result?: boolean;
  popup?: {
    title: string;
    message: string;
  };
  showPopup?: boolean;
  knownError?: KnownError;
  validatie?: {
    ok: boolean;
    melding: string;
  };
  ok?: boolean;
  melding?: string;
  success?: boolean;
  errorMessage?: string;
};

export type PickByType<Source, Type> = Pick<
  Source,
  { [K in keyof Source]: Source[K] extends Type ? K : never }[keyof Source]
>;

export type ValidInterval = Omit<Interval, 'start' | 'end'> & {
  start: DateTime;
  end: DateTime;
};

export enum NewOrEditState {
  New,
  Edit,
}

export type VerstuurWerknemerCommunicatieNotitieInput = {
  id?: number;
  notitie: string;
  onderwerp: string;
  verzendenAanId: number;
};

export type TaakDialogRefetchQueries = {
  mutateStap1: string[];
  mutateStap3: string[];
  mutateReopen: string[];
};

export enum PortaalToegang {
  AlleenOnline = 1, // Gebruiker heeft alleen rechten op Zorg van de Zaak Online
  AlleenPlanningsAgenda = 2, // Gebruiker bestaat niet in de [Login] tabel, we gaan ervanuit dat de klant volledige in PlanningsAgenda zit.
  Alle = 3, // Gebruiker heeft toegang tot alle portalen, zowel Zorg van de Zaak Online als PlanningsAgenda.
  Geen = 4, // Gebruiker heeft geen toegang tot een van beide portalen. SSO geauthenticeerd, maar niet geautoriseerd.
}
